"use strict";

exports.__esModule = true;
exports.applyElementDimensionConstraints = applyElementDimensionConstraints;
var _getWidget = require("./getWidget");
var _alignTo = require("./alignTo");
/**
 * Apply size and position constraints to the element tree starting at the given root,
 * returning a new tree with constraints applied.
 */
function applyElementDimensionConstraints(widgets, root) {
  var type = root.type,
    props = root.props;
  var widget = (0, _getWidget.getWidget)(widgets, root.type);
  var children = root.children.map(function (child) {
    return ensureConstraints(widgets, child, root, widget);
  });
  return {
    type: type,
    props: props,
    children: children
  };
}
function ensureConstraints(widgets, element, parent, parentWidget) {
  var widget = (0, _getWidget.getWidget)(widgets, element.type);
  var type = element.type,
    children = element.children;
  var props = {};
  for (var _i = 0, _Object$keys = Object.keys(element.props); _i < _Object$keys.length; _i++) {
    var key = _Object$keys[_i];
    if (!(parentWidget != null && parentWidget.suppliesProps.includes(key))) {
      props[key] = element.props[key];
    }
  }
  var defaultWidth;
  var defaultHeight;
  var minWidth;
  var minHeight;
  var maxWidth;
  var maxHeight;
  if ((widget == null ? void 0 : widget.propConstraints) !== undefined) {
    defaultWidth = widget == null ? void 0 : widget.propConstraints.width["default"];
    defaultHeight = widget == null ? void 0 : widget.propConstraints.height["default"];
    minWidth = widget == null ? void 0 : widget.propConstraints.width.min;
    minHeight = widget == null ? void 0 : widget.propConstraints.height.min;
    maxWidth = widget == null ? void 0 : widget.propConstraints.width.max;
    maxHeight = widget == null ? void 0 : widget.propConstraints.height.max;
  }
  var _props$x = props.x,
    x = _props$x === void 0 ? 0 : _props$x,
    _props$y = props.y,
    y = _props$y === void 0 ? 0 : _props$y,
    width = props.width,
    height = props.height;
  if (typeof x !== "number" || !Number.isFinite(x) || x < 1) {
    x = 0;
  }
  if (typeof y !== "number" || !Number.isFinite(y) || y < 1) {
    y = 0;
  }
  if (typeof width !== "number" || !Number.isFinite(width)) {
    width = defaultWidth;
  }
  if (typeof height !== "number" || !Number.isFinite(height)) {
    height = defaultHeight;
  }
  if (parent !== undefined) {
    maxWidth = Math.min(maxWidth, getContainerWidth(parent));
    maxHeight = Math.min(maxHeight, getContainerHeight(parent));
  }
  var availableWidth = maxWidth - x;
  var availableHeight = maxHeight - y;
  if (width > availableWidth) {
    width = availableWidth;
  }
  if (height > availableHeight) {
    height = availableHeight;
  }
  var itemWidth = props.itemWidth,
    itemHeight = props.itemHeight;
  if (typeof itemWidth === "number" && itemWidth > width) {
    props.itemWidth = width;
  }
  if (typeof itemHeight === "number" && itemHeight > height) {
    props.itemHeight = height;
  }
  props.x = Math.max(0, (0, _alignTo.alignTo)(x, 16));
  props.y = Math.max(0, (0, _alignTo.alignTo)(y, 16));
  props.height = (0, _alignTo.alignTo)(Math.max(minHeight, height), 16);
  props.width = (0, _alignTo.alignTo)(Math.max(minWidth, width), 16);
  return {
    type: type,
    props: props,
    children: children.map(function (child) {
      return ensureConstraints(widgets, child, element, widget);
    })
  };
}
function getContainerWidth(parent) {
  if (typeof parent.props.itemWidth === "number") {
    return parent.props.itemWidth;
  }
  if (typeof parent.props.width === "number") {
    return parent.props.width;
  }
  return 3840;
}
function getContainerHeight(parent) {
  if (typeof parent.props.itemHeight === "number") {
    return parent.props.itemHeight;
  }
  if (typeof parent.props.height === "number") {
    return parent.props.height;
  }
  return 2160;
}